import React from 'react';
import styled from 'styled-components';

const InputContainer = styled.div`
    display: ${props => props.inline ? 'flex' : ''};
    align-items: center;
    margin: 10px 0;
`;

const Label = styled.label`
    margin: 0 10px 0 0;
    font-weight: 600;
    color: #121180;
`;

const Encrypted = styled.span`
    color: #121180;
    background: #e9c46a;
    padding: 3px 5px;
    margin: 0 5px;
    font-size: 12px;
    border-radius: 3px;
`;

const InputField = styled.input`
    width: -webkit-fill-available;
    margin: ${props => !props.inline ? '8px 0 0 0' : 0};
    text-align: ${props => props.isArabic ? 'end' : 'start'};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    padding: 8px 10px;
    height: 40px;
    border-radius: 5px;
    border: 1px solid #121180;
    :hover{
        border: 1px solid #121180;
    }
    :focus{
        outline: none;
        border: 2px solid #121180;
    }
`;

export const TextAreaField = styled.textarea`
    width: -webkit-fill-available;
    margin: ${props => !props.inline ? '8px 0 0 0' : 0};
    text-align: ${props => props.isArabic ? 'end' : 'start'};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    padding: 8px 10px;
    border-radius: 5px;
    border: 1px solid #121180;
    :hover{
        border: 1px solid #121180;
    }
    :focus{
        outline: none;
        border: 2px solid #121180;
    }
`;

export const Input = ({ isArabic, id, label, arabiclabel, value, method, encrypt, maxLength, placeholder, arabicplaceholder, onChange, required, inline, error, disabled }) => (
    <InputContainer inline={inline}>
        {label && <Label className={isArabic ? 'arabic' : ''} isArabic={isArabic}>{isArabic ? arabiclabel : label} {required && <span style={{color: 'red', margin: '0 2px'}}>*</span>}{encrypt && <Encrypted>Encrypted</Encrypted>}</Label>}
        {/* <InputField id={id} isArabic={isArabic} inline={inline} value={value || ''} maxLength={maxLength} type={method} disabled={disabled} placeholder={(placeholder && placeholder.length > 0) ? (isArabic ? arabicplaceholder : placeholder) : `${isArabic ? 'دخول' : 'Enter the'} ${isArabic ? arabiclabel : label}`} onChange={onChange} required={required} /> */}
        <InputField id={id} isArabic={isArabic} inline={inline} value={value || ''} maxLength={maxLength} type={method} disabled={disabled} placeholder={(placeholder && placeholder.length > 0) ? (isArabic ? arabicplaceholder : placeholder) : `${isArabic ? '' : ''} ${isArabic ? arabiclabel : label}`} onChange={onChange} required={required} />
        {error && <p className="text-danger mt-1">{error}</p>}
    </InputContainer>
);

export const TextArea = ({ isArabic, label, arabiclabel, value, minLength, maxLength, method, placeholder, arabicplaceholder, rows, onChange, required, inline, disabled, error }) => (
    <InputContainer inline={inline}>
        {label && <Label className={isArabic ? 'arabic' : ''} isArabic={isArabic}>{isArabic ? arabiclabel : label} {required && <span style={{color: 'red', margin: '0 2px'}}>*</span>}</Label>}
        {/* <TextAreaField isArabic={isArabic} inline={inline} value={value || ''} minLength={minLength} maxLength={maxLength} disabled={disabled} rows={rows || 4} type={method} placeholder={(placeholder && placeholder.length > 0) ? (isArabic ? arabicplaceholder : placeholder) : `${isArabic ? 'دخول' : 'Enter the'} ${isArabic ? arabiclabel : label}`} onChange={onChange} required={required} /> */}
        <TextAreaField isArabic={isArabic} inline={inline} value={value || ''} minLength={minLength} maxLength={maxLength} disabled={disabled} rows={rows || 4} type={method} placeholder={(placeholder && placeholder.length > 0) ? (isArabic ? arabicplaceholder : placeholder) : `${isArabic ? '' : ''} ${isArabic ? arabiclabel : label}`} onChange={onChange} required={required} />
        {error && <p className="text-danger mt-1">{error}</p>}
    </InputContainer>
);